import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import './Educators.component.css'
const Educators = () => {
  const EducatorsData = [
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature2,
      bgColor: "rgba(247, 255, 250, 1)",
      time1: "10:00 AM",
      time2: "10:00 AM",
      days: [
        {
          name: "San",
          color: "rgba(0, 0, 0, 1)",
        },
        {
          name: "Mon",
          color: "rgba(96, 31, 235, 1)",
        },
        {
          name: "Tue",
          color: "rgba(96, 31, 235, 1)",
        },
        {
          name: "Wed",
          color: "rgba(0, 0, 0, 1)",
        },
        {
          name: "Thu",
          color: "rgba(0, 0, 0, 1)",
        },
        {
          name: "Fri",
          color: "rgba(96, 31, 235, 1)",
        },
        {
          name: "Sat",
          color: "rgba(0, 0, 0, 1)",
        },
      ],
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature3,
      bgColor: "rgba(247, 255, 250, 1)",
      time1: "10:00 AM",
      time2: "10:00 AM",
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature4,
      bgColor: "rgba(247, 255, 250, 1)",
      time1: "10:00 AM",
      time2: "10:00 AM",
    },
    {
      name: "FRX Educators",
      subName: "FRX Futures",
      logo: Img.FeatureLogo,
      img: Img.feature2,
      bgColor: "rgba(247, 255, 250, 1)",
      time1: "10:00 AM",
      time2: "10:00 AM",
    },
  ];
  return (
    <VStack py="35px" w="100%" overflow={"hidden"}>
      {/* desktop-version */}
      <Stack w="100%" h="100%" className="desktop-version">
        <Stack
          flexDir="row"
          justifyContent="space-between"
          alignItems={"center"}
          w="100%"
        >
          <Box>
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="36px"
              fontWeight={"700"}
              fontFamily={" 'Poppins', sans-serif;"}
            >
              General Educators
            </Text>
          </Box>
          <Box>
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="20px"
              fontWeight={"400"}
              cursor={"pointer"}
              fontFamily={"ProximaNova"}
            >
              See all
            </Text>
          </Box>
        </Stack>

        <Stack
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
          gap={"0"}
          w="100%"
        >
          {EducatorsData.map((item) => (
            <Box w="25%">
              <Box
                h="auto"
                boxShadow="0px 0px 11px 0px rgba(0, 0, 0, 0.13)"
                borderRadius="18px"
                margin="15px"
              >
                <Box textAlign="center" py="20px">
                  <Text
                    fontSize="20px"
                    fontWeight="400"
                    color="rgba(0, 0, 0, 1)"
                  >
                    {item.name}
                  </Text>
                  <Text
                    color="rgba(0, 0, 0, 1)"
                    fontSize="20px"
                    fontWeight="700"
                    mt="0"
                  >
                    {item.subName}
                  </Text>
                </Box>
                {/* Days */}
                <Stack flexDir="row" p="18px">
                  <Box w="33%">
                    <Text
                      fontSize="16px"
                      fontWeight={"600"}
                      fontFamily={" 'Poppins', sans-serif;"}
                      color="rgba(0, 0, 0, 1)"
                    >
                      EST
                    </Text>
                    <Box>
                      <Text
                        borderRadius="37px"
                        bg="rgba(149, 151, 171, 1)"
                        padding={"2px 4px"}
                        fontSize={"10px"}
                        fontWeight={"600"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(255, 255, 255, 1)"
                        textAlign={"center"}
                        mt="20px"
                      >
                        {item.time2}
                      </Text>
                    </Box>
                  </Box>
                  <Box w="33%">
                    <Text
                      textAlign="center"
                      fontSize="16px"
                      fontWeight={"600"}
                      fontFamily={" 'Poppins', sans-serif;"}
                      color="rgba(0, 0, 0, 1)"
                    >
                      Day
                    </Text>
                    <Box display="flex" flexDirection={"column"}>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Sun
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(96, 31, 235, 1)"
                      >
                        Mon
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Wed
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Thu
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(96, 31, 235, 1)"
                      >
                        Fri
                      </Text>

                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Sat
                      </Text>
                    </Box>
                  </Box>
                  <Box w="33%">
                    <Text
                      textAlign="right"
                      fontSize="16px"
                      fontWeight={"600"}
                      fontFamily={" 'Poppins', sans-serif;"}
                      color="rgba(0, 0, 0, 1)"
                    >
                      CDT
                    </Text>
                    <Box>
                      <Text
                        borderRadius="37px"
                        bg="rgba(149, 151, 171, 1)"
                        padding={"2px 4px"}
                        fontSize={"10px"}
                        fontWeight={"600"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(255, 255, 255, 1)"
                        textAlign={"center"}
                        mt="20px"
                      >
                        {item.time1}
                      </Text>
                    </Box>
                  </Box>
                </Stack>
                <Box
                  w="85%"
                  mx="auto"
                  h={"303px"}
                  position="relative"
                  paddingBottom="20px"
                >
                  <Image
                    src={item.logo}
                    alt="logo"
                    position={"absolute"}
                    top="10px"
                    left={"10px"}
                    w={"57px"}
                  />
                  <Image
                    src={item.img}
                    alt="logo"
                    w="100%"
                    borderRadius="32px"
                    h="100%"
                    objectFit={item.tm1 === true ? "contain" : "cover"}
                  />
                </Box>
              </Box>
            </Box>
          ))}
        </Stack>
      </Stack>

      {/* desktop-version */}
      <Stack w="100%" h="100%" className="mobile-version">
        <Stack
          justifyContent="space-between"
          alignItems={"center"}
          w="100%"
        >
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="24px"
              fontWeight={"600"}
              fontFamily={" 'Poppins', sans-serif;"}
            >
              General Educators
            </Text>
        </Stack>

        <Stack
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
          gap={"0"}
          w="100%"
          pt="30px"
        >
          {EducatorsData.map((item) => (
            <Box w="100%">
              <Box
                h="auto"
                boxShadow="0px 0px 11px 0px rgba(0, 0, 0, 0.13)"
                borderRadius="18px"
                margin="15px"
              >
                <Box textAlign="center" py="20px">
                  <Text
                    fontSize="20px"
                    fontWeight="400"
                    color="rgba(0, 0, 0, 1)"
                  >
                    {item.name}
                  </Text>
                  <Text
                    color="rgba(0, 0, 0, 1)"
                    fontSize="20px"
                    fontWeight="700"
                    mt="0"
                  >
                    {item.subName}
                  </Text>
                </Box>
                {/* Days */}
                <Stack flexDir="row" p="18px">
                  <Box w="33%">
                    <Text
                      fontSize="16px"
                      fontWeight={"600"}
                      fontFamily={" 'Poppins', sans-serif;"}
                      color="rgba(0, 0, 0, 1)"
                    >
                      EST
                    </Text>
                    <Box>
                      <Text
                        borderRadius="37px"
                        bg="rgba(149, 151, 171, 1)"
                        padding={"2px 4px"}
                        fontSize={"10px"}
                        fontWeight={"600"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(255, 255, 255, 1)"
                        textAlign={"center"}
                        mt="20px"
                      >
                        {item.time2}
                      </Text>
                    </Box>
                  </Box>
                  <Box w="33%">
                    <Text
                      textAlign="center"
                      fontSize="16px"
                      fontWeight={"600"}
                      fontFamily={" 'Poppins', sans-serif;"}
                      color="rgba(0, 0, 0, 1)"
                    >
                      Day
                    </Text>
                    <Box display="flex" flexDirection={"column"}>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Sun
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(96, 31, 235, 1)"
                      >
                        Mon
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Wed
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Thu
                      </Text>
                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(96, 31, 235, 1)"
                      >
                        Fri
                      </Text>

                      <Text
                        textAlign="center"
                        fontSize="14px"
                        fontWeight={"400"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(0, 0, 0, 1)"
                      >
                        Sat
                      </Text>
                    </Box>
                  </Box>
                  <Box w="33%">
                    <Text
                      textAlign="right"
                      fontSize="16px"
                      fontWeight={"600"}
                      fontFamily={" 'Poppins', sans-serif;"}
                      color="rgba(0, 0, 0, 1)"
                    >
                      CDT
                    </Text>
                    <Box>
                      <Text
                        borderRadius="37px"
                        bg="rgba(149, 151, 171, 1)"
                        padding={"2px 4px"}
                        fontSize={"10px"}
                        fontWeight={"600"}
                        fontFamily={" 'Poppins', sans-serif;"}
                        color="rgba(255, 255, 255, 1)"
                        textAlign={"center"}
                        mt="20px"
                      >
                        {item.time1}
                      </Text>
                    </Box>
                  </Box>
                </Stack>
                <Box
                  w="85%"
                  mx="auto"
                  h={"303px"}
                  position="relative"
                  paddingBottom="20px"
                >
                  <Image
                    src={item.logo}
                    alt="logo"
                    position={"absolute"}
                    top="10px"
                    left={"10px"}
                    w={"57px"}
                  />
                  <Image
                    src={item.img}
                    alt="logo"
                    w="100%"
                    borderRadius="32px"
                    h="100%"
                    objectFit={item.tm1 === true ? "contain" : "cover"}
                  />
                </Box>
              </Box>
            </Box>
          ))}
        </Stack>
      </Stack>
    </VStack>
  );
};

export default Educators;
